import React from 'react';
import { observer } from 'mobx-react-lite';
import { useSearchParams } from 'react-router-dom';

import './style.sass';

import { Page } from 'app/components/common/PageLayout';
import { useBreakpointType } from 'app/services/breakpoints';
import { useModelWithArguments } from 'app/hooks/useViewModel';
import { UserInnerPageViewModel } from 'app/viewModels/pages/UserInnerPageViewModel';
import { UserInnerTable } from 'app/components/UserInnerTable';
import { UserInnerCardsList } from 'app/components/UserInnerCardsList';
import { Routes } from 'src/types/routes';
import { Button } from 'app/components/common/Button';
import { AttentionMessage } from 'app/components/common/AttentionMessage';


export const UserInnerPage = observer(() => {
    const [searchParams] = useSearchParams();
    const userId = searchParams.get(Routes.Args.UserId);

    const {
        userCampaigns,
        isLoading,
        hasMore,
        handleClickLoadMore,
    } = useModelWithArguments(UserInnerPageViewModel, userId);

    const { isMobile } = useBreakpointType();

    const hasCampaigns = !!userCampaigns && !!userCampaigns.length;

    return (
        <Page className="user-inner-page" isLoading={isLoading}>
            {hasCampaigns && (
                <>
                    {isMobile
                        ? <UserInnerCardsList campaigns={userCampaigns} />
                        : <UserInnerTable campaigns={userCampaigns} />
                    }

                    {hasMore && (
                        <div className="user-inner-page__btn">
                            <Button
                                size="big"
                                colorType="primary-light"
                                text="Load more"
                                className="user-inner-page__load-more-btn"
                                onClick={handleClickLoadMore}
                            />
                        </div>
                    )}
                </>
            )}
            {!hasCampaigns && (
                <div className="user-inner-page__empty-state">
                    <AttentionMessage
                        title="No campaigns yet"
                        desc="This user currently has no campaigns."
                    />
                </div>
            )}
        </Page>
    );
});
